<template>
  <el-dialog :title="scheduleVis ? $t('lang.addSchedule') : $t('lang.addFormat')" :visible.sync="visible" width="600px" :before-close="handleClose">
    <div class="ScheduleClass" v-if="scheduleVis">
      <div>{{$t('lang.dateStyle')}}</div>
      <el-select v-model="form.scheduleType" :placeholder="$t('lang.choice')">
        <el-option :label="$t('lang.Weekly')" value="1"></el-option>
        <el-option :label="$t('lang.Dayly')" value="2"></el-option>
      </el-select>
    </div>
    <div class="ScheduleClass">
      <div>{{$t('lang.name')}}</div>
      <el-input type="text" v-model="form.nickName" autocomplete="off" maxlength="32"></el-input>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button class="cancel" @click="handleClose">{{ $t("lang.cancel") }}</el-button>
        <el-button class="save" type="primary" @click="save()">{{ $t("lang.next") }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import toTips from '@/assets/js/toTipsObj'
// const googleKey = 'playout';
export default {
  props: {
    scheduleVis: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: true,
      title: '',
      spliceTypeValue: '0',
      options: [
        {
          value: '0',
          label: 'Start Normal'
        },
        {
          value: '1',
          label: 'Start Immediate'
        },
        {
          value: '2',
          label: 'End Normal'
        },
        {
          value: '3',
          label: 'End Immediate'
        },
        {
          value: '4',
          label: 'Cancel'
        }
      ],
      form: {
        nickName: '',
        scheduleType: '1'
      }
    }
  },
  created () {
  },
  computed: {},
  watch: {
  },

  methods: {
    save () {
      if (!this.form.nickName.trim()) {
        this.$message.error(this.$t('lang.nameEmpty'))
        return
      }
      const params = {
        name: this.form.nickName,
        type: '1',
        scheduleType: this.form.scheduleType
      }
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/template/add', params).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            res.data.result.status = true
            this.$emit('visible', res.data.result)
            Bus.$emit('nextAdd', true)
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }
      }).catch(() => {})
    },
    // 取消创建
    cancel () {
      this.handleClose()
    },

    // 关闭弹窗
    handleClose (manualClose) {
      this.$emit('visible', { status: false, name: 'scheduleVis' })
    }
  }
}
</script>

<style lang="less" scoped>
.ScheduleClass {
  margin-bottom: 15px;
}
::v-deep .el-input__inner {
  background: #444 !important;
}
::v-deep .el-select {
  display: block;
}
</style>
